export const UserRole = {
    Student : 'profile',
    Manager : 'manager',
    Admin : 'admin',
    NotAuthorized :'notAuthorized'
}